export const GET_TRAIL_COURSE_SUCCESS = 'GET_TRAIL_COURSE_SUCCESS';
export const FILTER_TRAIL_COLLECTION_BOOK = 'FILTER_TRAIL_COLLECTION_BOOK';
export const ADD_VIDEO_TO_FAVORITE_LIST = 'ADD_VIDEO_TO_FAVORITE_LIST';
export const REMOVE_UNFOLLOW_VIDEOS = 'REMOVE_UNFOLLOW_VIDEOS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
